import axios from 'axios';
import config from '@/vue-caas/config/config.js';

import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import appUtil from '@/vue-dlb/utils/app-util'

import {
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  callByDataSet,
} from "@/vue-dlb/utils/backend-util.js";

const baseURI = config.companyApiUrl;
const commonURI = config.commonApiUrl;

const codesStoreModule = {
  // namespaced: false,

  state: {
    // ediIdList: [],
    // ediIdListTemp: [],
    // compEdiIdList: [],
    // prnrEdiIdList: [],
    // chkEdiId: {},
    srchKeyList: [],
    srchKeyListTemp: [],
    msgCdList: [],
    msgCdListTemp: [],
    stCdList: [],
    stCdListTemp: [],
  },
  mutations: {
    'SET_STORE_SRCHKEY_LIST' (state, srchKeyList) {
      srchKeyList === '' ? state.srchKeyList = [] : state.srchKeyList = srchKeyList;
      srchKeyList === '' ? state.srchKeyListTemp = [] : state.srchKeyListTemp = srchKeyList;
    },
    'SET_STORE_SRCHKEY_LIST_FILTER' (state, filter) {
      let datarows = state.srchKeyListTemp;
      state.filter = filter;
      let filterBy = state.filter;
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter(item =>  {
          if(filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
          return false;
        });
      }
      state.srchKeyList = listResult;
    },
    'SET_STORE_MSGCD_LIST' (state, msgCdList) {
      msgCdList === '' ? state.msgCdList = [] : state.msgCdList = msgCdList;
      msgCdList === '' ? state.msgCdListTemp = [] : state.msgCdListTemp = msgCdList;
    },

    'SET_STORE_MSGCD_LIST_FILTER' (state, filter) {
      let datarows = state.msgCdListTemp;
      state.filter = filter;
      let filterBy = state.filter;
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter(item =>  {
          if(filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
          return false;
        });
      }
      state.msgCdList = listResult;
    },

    'SET_STORE_STCD_LIST' (state, stCdList) {
      stCdList === '' ? state.stCdList = [] : state.stCdList = stCdList;
      stCdList === '' ? state.stCdListTemp = [] : state.stCdListTemp = stCdList;
    },

    'SET_STORE_STCD_LIST_FILTER' (state, filter) {
      let datarows = state.stCdListTemp;
      state.filter = filter;
      let filterBy = state.filter;
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter(item =>  {
          if(filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
          return false;
        });
      }
      state.stCdList = listResult;
    },
  },
  actions: {
    getSearchKeyList: async ({commit}, params) => {

      try {
        const response = await axios.post(`${commonURI}/common/srchkey/list`, params);
        // console.log("getSrchKeyList : " + JSON.stringify(response.data));
        commit('SET_STORE_SRCHKEY_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },

    insertSearchKey: async ({commit}, params) => {
      try {
        const response = await axios.post(`${commonURI}/common/srchkey/insert`, params);
        console.log("insertSrchKey : " + JSON.stringify(response.data));
        commit('SET_STORE_SRCHKEY_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },

    updateSearchKey: async ({commit}, params) => {
      try {
        const response = await axios.post(`${commonURI}/common/srchkey/update`, params);
        console.log("updateSrchKey : " + JSON.stringify(response.data));
        commit('SET_STORE_SRCHKEY_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },

    deleteSearchKey: async ({commit}, params) => {
      try {
        const response = await axios.post(`${commonURI}/common/srchkey/delete`, params);
        console.log("deleteSearchKey : " + JSON.stringify(response.data));
        commit('SET_STORE_SRCHKEY_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },

    getMessageCodeList: async ({ commit }, params) => {
      let retSet = new ObjDataSet("msgCodeList");
      let condSet = new ObjDataSet("condSet");
      let trSet = new ObjTrSet("msgCodeList");
      condSet = appUtil.addDataHeader(params, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.AddDataSet("O", "DS02", retSet);
      trSet.tranID = "EDP_CODE_MAN_MSG_LIST_FN";
      const reqdata = selectDataSetByDataSet(trSet);
      const response = await api.putData("UserDispatcherServlet", reqdata);
        // console.log("getMessageCodeList : " + JSON.stringify(response.data.DataSets));
        commit('SET_STORE_MSGCD_LIST', response.data.DataSets[0].DataRows);
    },

    insertMessageCode: async ({commit}, params) => {
      let insertMaster = params[0];
      const retSet = new ObjDataSet("rtnPrcsNo");
      let condSet = new ObjDataSet("condSet");
      const trSet = new ObjTrSet("addMessageCode");
      condSet = appUtil.addDataHeader(insertMaster, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.AddDataSet("O", "DS02", retSet);
      trSet.tranID = "CodeManagementManager";
      trSet.tranMethod = "addMessageCode";
      const reqdata = callByDataSet(trSet);
      const response =  await api.putData("UserDispatcherServlet", reqdata);
        console.log("insertMessageCode : " + JSON.stringify(response));
        commit('SET_STORE_MSGCD_LIST', response.data);
    },

    updateMessageCode: async ({ commit }, params) => {
      let condSet = new ObjDataSet("condSet");
      const trSet = new ObjTrSet("modifyMessageCode");
      condSet = appUtil.addDataHeader(params, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.tranID = "CodeManagementManager";
      trSet.tranMethod = "modifyMessageCode";
      const reqdata = callByDataSet(trSet);
      const response =  await api.putData("UserDispatcherServlet", reqdata);
        console.log("updateMessageCode : " + JSON.stringify(response));
        commit('SET_STORE_MSGCD_LIST', response.data);
    },

    deleteMessageCode: async ({ commit }, params) => {
      let condSet = new ObjDataSet("condSet");
      const trSet = new ObjTrSet("deleteMessageCode");
      condSet = appUtil.addDataHeader(params, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.tranID = "CodeManagementManager";
      trSet.tranMethod = "deleteMessageCode";
      const reqdata = callByDataSet(trSet);
      const response =  await api.putData("UserDispatcherServlet", reqdata);
          console.log("deleteMessageCode : " + JSON.stringify(response));
          commit('SET_STORE_MSGCD_LIST', response.data);
    },

    getSiteCodeList: async ({ commit }, params) => {
      let retSet = new ObjDataSet("stCodeList");
      let condSet = new ObjDataSet("condSet");
      let trSet = new ObjTrSet("stCodeList");
      condSet = appUtil.addDataHeader(params, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.AddDataSet("O", "DS02", retSet);
      trSet.tranID = "EDP_CODE_MAN_SITE_LIST_FN";
      const reqdata = selectDataSetByDataSet(trSet);
      const response = await api.putData("UserDispatcherServlet", reqdata);
        // console.log("getSiteCodeList : " + JSON.stringify(response.data.DataSets));
        commit('SET_STORE_STCD_LIST', response.data.DataSets[0].DataRows);
    },

    insertSiteCode: async ({commit}, params) => {
      let insertMaster = params[0];
      const retSet = new ObjDataSet("rtnPrcsNo");
      let condSet = new ObjDataSet("condSet");
      const trSet = new ObjTrSet("addSiteCode");
      condSet = appUtil.addDataHeader(insertMaster, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.AddDataSet("O", "DS02", retSet);
      trSet.tranID = "CodeManagementManager";
      trSet.tranMethod = "addSiteCode";
      const reqdata = callByDataSet(trSet);
      const response =  await api.putData("UserDispatcherServlet", reqdata);
        // console.log("insertSiteCode : " + JSON.stringify(response));
        commit('SET_STORE_STCD_LIST', response.data);
    },

    updateSiteCode: async ({ commit }, params) => {
      let condSet = new ObjDataSet("condSet");
      const trSet = new ObjTrSet("modifySiteCode");
      condSet = appUtil.addDataHeader(params, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.tranID = "CodeManagementManager";
      trSet.tranMethod = "modifySiteCode";
      const reqdata = callByDataSet(trSet);
      const response =  await api.putData("UserDispatcherServlet", reqdata);
        // console.log("updateSiteCode : " + JSON.stringify(response));
        commit('SET_STORE_STCD_LIST', response.data);
    },

    deleteSiteCode: async ({ commit }, params) => {
      let condSet = new ObjDataSet("condSet");
      const trSet = new ObjTrSet("deleteSiteCode");
      condSet = appUtil.addDataHeader(params, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.tranID = "CodeManagementManager";
      trSet.tranMethod = "deleteSiteCode";
      const reqdata = callByDataSet(trSet);
      const response =  await api.putData("UserDispatcherServlet", reqdata);
          // console.log("deleteSiteCode : " + JSON.stringify(response));
          commit('SET_STORE_STCD_LIST', response.data);
    },
  },
  getters: {
    srchKeyList: state => state.srchKeyList,
    msgCdList: state => state.msgCdList,
    stCdList: state => state.stCdList,
    // ediIdList: state => state.ediIdList,
    // compEdiIdList: state => state.compEdiIdList,
    // prnrEdiIdList: state => state.prnrEdiIdList,
    // chkEdiId: state => state.chkEdiId,
  },
};

export default codesStoreModule;
